module.exports = __webpack_public_path__ + "static/media/icon-user.e3ff7230.svg";